/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../../store/store';
import Finances from '../../../widgets/Finances';
import Carousel from '../../../shared/Carousel';
import posterImg from '../../../../_metronic/assets/media/bonus.png';
import { Button } from '../../../shared/Buttons';
import Card from '../../../shared/Card';
import PageWrapper from '../../../modules/PageWrapper';
import { Link } from 'react-router-dom';
import Chart from '../../../widgets/Chart';
import { formatNumberToCash, formatNumber, formatNumber2 } from '../../../functions/formatNumber';

const DashboardPage = observer(({ timeConfig, isVerify, setPreloader }) => {
  const store = useStore();

  const [salesStats, setSalesStats] = useState({});
  const [qualificationSchedule, setQualificationSchedule] = useState([]);
  const [ltcStats, setLtcStats] = useState();
  const [forecast, setForecast] = useState();

  useEffect(() => {
    isVerify && timeConfig.time_config && getData();
  }, [isVerify, timeConfig]);

  const getData = async () => {
    const getSalesStats = await store.requestGet(
      `user/sales/ltc/manager/statistics`,
      {
        params: timeConfig,
      },
      true
    );
    const getLtcStats = await store.requestGet(`Dashboard/Sales/Ltc/Manager/getLtcStats`, {
      params: timeConfig,
    });
    const getForecast = await store.requestGet(`Dashboard/Sales/Ltc/Manager/getForecastPayout`);

    const ltcList = await store.requestGet('Finance/Category/getLtcList');

    const ltc = ltcList.find(
      (el) => +getLtcStats.ltc >= +el.ltc_min && +getLtcStats.ltc <= +el.ltc_max
    );

    if (!Object.keys(qualificationSchedule).length) {
      const getQualificationSchedule = await store.requestGet(
        `Dashboard/Sales/Ltc/Manager/qualificationSchedule`
      );
      setQualificationSchedule(getQualificationSchedule);
    }

    setForecast(getForecast);
    setLtcStats({ ...getLtcStats, indicator: ltc });
    setSalesStats(getSalesStats);
    setPreloader(false);
  };

  return (
    <>
      <div className='row g-5 g-xl-10 mt-0'>
        <div className='col-xl-4 mb-xl-10 mt-0'>
          <Finances
            background={'bg_ltc_manager'}
            title='Статистика'
            subTitle='Управляйте периодом в календаре.'
            stats={[
              {
                title: 'Чаты',
                number: formatNumber(salesStats?.chats_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Регистрации',
                number: formatNumber(salesStats?.registrations_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-edit fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Квалификации',
                number: formatNumber(salesStats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'LTC',
                number: `${formatNumber2(salesStats?.chat_to_qualification)}%` || 0,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
            ]}
          />
        </div>

        <div className='col-xl-8 mb-5 mb-xl-10 mt-xl-0'>

          <style>

          </style>
          <Card className='card' data-bs-theme='light' style={{
            background: 'radial-gradient(1200px 800px at 50% 35%, #2a2f42 0%, #12131a 40%, #07070a 100%)'
          }}>
            <div className='card-body d-flex ps-xl-15'>
              <div className='m-0'>
                <div className='position-relative fs-2x z-index-2 fw-bold text-white mb-7'>
                  <span className='me-2'>
                    Приведи менеджера и получи{' '}
                    <span className='position-relative d-inline-block text-danger'>
                      <span className='text-danger opacity-75-hover'>100$</span>

                      <span className='position-absolute opacity-50 bottom-0 start-0 border-4 border-danger border-bottom w-100'></span>
                    </span>
                  </span>
                  за каждого.
                  <br /> Условия по кнопке ниже!
                </div>
                <a
                  href='https://t.me/priority0000'
                  target='_blank'
                  className='btn fw-bold  btn-danger cursor-pointer'
                  rel='noreferrer'
                >
                  Подробнее
                </a>
              </div>

              <img
                src={posterImg}
                className='position-absolute me-3 bottom-0 end-0 h-200px'
                alt=''
              />
            </div>
          </Card>
        </div>

      </div>
    </>
  );
});

const ManagerLTC = () => {
  return (
    <PageWrapper
      firstTimeConfig='current_week'
      mode='sales'
      breadcrumbs={[
        { title: 'Panel', path: '' },
        { isSeparator: true },
        { title: 'Панель', path: '/dashboard/manager/ltc', isActive: true },
      ]}
      title={'Панель'}
    >
      <DashboardPage />
    </PageWrapper>
  );
};

export default ManagerLTC;
